// @ts-check

import React, { Component, Fragment } from "react"
import Button from "ui/legacy/Button"
import PropertiesContext from "../../properties/PropertiesContext"
import { BlockContextConsumer } from "../../ContextProviders"
import DefineAction from "../../actions/DefineAction"
import { selectFormAction } from "../../attributes/items/actions/formActions"
import { text, keyvaluelist } from "../../attributes/items/primitives"
import { withRouter } from "react-router"
import Droppable from "../../../editor/dnd/Droppable"

import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { actionActions, getActions, getActionEntities } from "data/actionApi"
import { throws } from "assert"

const deepcopy = require("deepcopy")
/**
 * @augments {Component<BlockTypeProps & {localProperties: Broadcast_Property[], getPropertyValue: (name: string) => any}, any>}
 */
class FormBlockType extends Component {
    state = {
        isLoading: false,
        isLoaded: false,
        hasError: false,
        hasChanges: false,
    }

    constructor(props) {
        super(props)
        props.actionActions.fetch()
    }

    redirectToLink = (attrs, evaluateFormulas, results) => {
        if (attrs.link) {
            const link = evaluateFormulas(attrs.link, results)
            if (link.indexOf("://") !== -1) {
                window.location = link
            } else {
                this.props.router.push(link)
            }
        } else {
            return Promise.resolve()
        }
    }

    submit = ({ attrs, evaluateFormulas, actionEntities, exec }) => {
        if (this.props.context.isEditing) {
            return
        }
        this.setState({ isLoading: true })

        // Calculate the properties
        let values = propertiesToJson(this.props.localProperties, this.props.getPropertyValue)
        if (attrs.extra) {
            const extraValues = attrs.extra.map(evaluateFormulas)

            extraValues.forEach(extra => (values[extra.key] = evaluateFormulas(extra.value)))
        }
        console.log("Props", values)

        // Now run the action
        const action = actionEntities[attrs.action]

        console.log("EEntities", actionEntities)
        if (action) {
            var promise = exec(action, values)

            return promise.then(results => {
                return this.redirectToLink(attrs, evaluateFormulas, results)
            })
        }
    }
    render() {
        const Wrapper = this.props.Wrapper

        return (
            <Wrapper {...this.props}>
                {({ attrs, DropBox, evaluateFormulas }) => {
                    const actionParams = {
                        attrs,
                        evaluateFormulas,
                        actionEntities: this.props.entities,
                        exec: this.props.actionActions.exec,
                    }
                    const key = JSON.stringify(actionParams)
                    const submit = () => this.submit(actionParams)
                    return (
                        <Fragment>
                            {!this.props.childBlocks ? (
                                <div className=" drop-here">{this.props.renderDroppable(null)}</div>
                            ) : (
                                this.props.renderDroppable(null, this.props.childBlocks.length)
                            )}
                            {/* This is a form, welcome.<br />
                        My values are: <br />
                        <pre>{JSON.stringify(this.propertiesToJson(), null, 4)}</pre> */}
                            {this.props.childBlocks.length === 0 ? (
                                <div className="display-flex flex-column position-relative drop-here">
                                    {this.props.renderDroppable(null)}
                                </div>
                            ) : (
                                <div className="display-flex flex-column position-relative">
                                    {this.props.utils.renderChildren(this.props.childBlocks)}
                                </div>
                            )}
                            {/* <Button
                            type="success"
                            onClick={this.submit}
                            disabled={this.state.isLoading}
                            icon={this.state.isLoading ? "clock-o" : undefined}
                        >
                            Submit
                        </Button> */}

                            <DefineAction
                                key={key}
                                name={this.props.id + ": Submit form"}
                                action={submit}
                            />
                        </Fragment>
                    )
                }}
            </Wrapper>
        )
    }
}

function mapStateToProps(state) {
    return {
        actions: getActions(state),
        entities: getActionEntities(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actionActions: bindActionCreators(actionActions, dispatch),
    }
}

const RoutedFormBlock = withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(FormBlockType)
)

const propertiesToJson = (localProperties, getPropertyValue) => {
    return localProperties.reduce((acc, { published_name, id }) => {
        acc[published_name] = getPropertyValue(id)
        return acc
    }, {})
}

export default function FormBlockTypeWithPropertyBoundary(props) {
    return (
        <BlockContextConsumer>
            {context => (
                <PropertiesContext when={({ tags = [] }) => tags.indexOf("form") >= 0}>
                    {({ localItems }) => (
                        <RoutedFormBlock
                            {...props}
                            localProperties={localItems}
                            getPropertyValue={context.propertyStore.get}
                        />
                    )}
                </PropertiesContext>
            )}
        </BlockContextConsumer>
    )
}

FormBlockTypeWithPropertyBoundary.attributes = [
    selectFormAction({ field: "action", label: "Form action" }),
    text({ field: "link", label: "Redirect after submission" }),
    keyvaluelist({ field: "extra", label: "Extra data", keyName: "key", valueName: "value" }),
]

// FormBlockTypeWithPropertyBoundary.renderAttributes = ({
//     attributes,
//     renderAttribute,
//     configuredAttributes,
// }) => {
//     // get blockID
//     return (
//         <Fragment>
//             {attributes.map(renderAttribute)}
//             <BlockContextConsumer>
//                 {context => (
//                     <PropertiesContext when={({ tags = [] }) => tags.indexOf("form") >= 0}>
//                         {({ localItems }) => (
//                             <pre>
//                                 Values {JSON.stringify(localItems)}
//                                 {JSON.stringify(
//                                     propertiesToJson(localItems, context.propertyStore.get),
//                                     null,
//                                     4
//                                 )}
//                             </pre>
//                         )}
//                     </PropertiesContext>
//                 )}
//             </BlockContextConsumer>
//         </Fragment>
//     )
// }



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/form/FormBlock.js